class Revue {
  constructor () {
    this.slideshowRevues();
  }
  slideshowRevues() {
    $(window).on('load', function(){
      const parentRevueView = document.getElementById('block-derniere-revue-des-parents');
      const parentRevueNavView = document.getElementById('block-views-block-revue-des-parents-nav');
      const slideshowContainerSelector = '.slideshow-revues';
      if (!parentRevueNavView && !parentRevueView) {
        const slideshowContainer = document.querySelector(slideshowContainerSelector);
        slideshowContainer && slideshowContainer.remove();
      }

      // Adds the two views to one container for display
      if (parentRevueView) {
        $(parentRevueView).appendTo(".slideshow-revues");
        const parentRevueViewContent = parentRevueView.querySelector('.view-content');

        parentRevueViewContent && $(parentRevueViewContent).slick({
          infinite: true,
          autoplay: true,
          autoplaySpeed: 5000,
          focusOnSelect: true,
          asNavFor: 'div[id^=block-views-block-revue-des-parents-nav] .view-content'
        })
      }

      if (parentRevueNavView) {
        $(parentRevueNavView).appendTo(".slideshow-revues");
        const parentRevueNavViewContent = parentRevueNavView.querySelector('.view-content');

        parentRevueNavViewContent && $(parentRevueNavViewContent).slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          focusOnSelect: true,
          asNavFor: 'div[id^=block-derniere-revue-des-parents] .view-content'
        });
      }
    });
  }
}

export default Revue;
